import { useTranslation } from "react-i18next";
import Counter from "~/src/components/Counter/Counter";
import { useFormDataContext } from "~/src/contexts/FormDataContext/FormDataContext";
import { settElgFields } from "./ElgTypes";
import { JaktdagElgFormDataContext } from "./RegistrerElg";

const SettCountersElg = () => {
  const { t } = useTranslation();
  const { formData, setFormData, formErrors } = useFormDataContext(JaktdagElgFormDataContext);

  return (
    <div>
      {settElgFields.map((dyrType) => {
        return (
          <Counter
            key={dyrType}
            id={dyrType}
            label={t(`pages.registrerArt.elg.sett.${dyrType}`)}
            error={
              formErrors[dyrType] ? t("form.fields.settAntall.validationErrorShort") : undefined
            }
            onCountChanged={(count) => {
              const _formData = { ...formData };
              _formData[dyrType] = count;
              setFormData({ ..._formData });
            }}
            value={formData[dyrType] as number}
            errorIcon
          />
        );
      })}
    </div>
  );
};

export default SettCountersElg;
